import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._2yhol{display:flex;align-items:center;font-size:12px;line-height:16px;min-height:16px}._3p8to{color:#74777a;fill:#74777a}._1dqdZ{color:#b00;fill:#b00}._1ibrA,._2rIWr{margin-left:-2px;margin-right:3px}";
var styles = {"caption":"_2yhol","helperText":"_3p8to","errorText":"_1dqdZ","errorIcon":"_1ibrA","readOnlyIcon":"_2rIWr"};
var stylesheet="._2yhol{display:flex;align-items:center;font-size:12px;line-height:16px;min-height:16px}._3p8to{color:#74777a;fill:#74777a}._1dqdZ{color:#b00;fill:#b00}._1ibrA,._2rIWr{margin-left:-2px;margin-right:3px}";
styleInject(css_248z);

export { styles as default, stylesheet };
